/* eslint-disable */
import React, { useEffect, useState } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Button,
  Flex,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import AddEditCategoryDrawer from "./AddEditCategoryDrawer";
import ConfirmDeleteAlert from "./ConfirmDeleteAlert";
import axiosClient from "../../../api/axiosClient";
import CategoryDetailDialog from "./components/CategoryDetailDialog";

import { IconButton, Tooltip } from "@chakra-ui/react";
import { ViewIcon } from "@chakra-ui/icons";


export default function DynamicTable({ columnsData, endpoint }) {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState({});
  const [page, setPage] = useState(1);

  const [selectedRow, setSelectedRow] = useState(null); // for edit/delete
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const loadData = async () => {
    const res = await axiosClient.get(`${endpoint}?page=${page}`);
    setData(res.data.data);
    setMeta(res.data.meta);
  };

  useEffect(() => {
    loadData();
  }, [page]);

  // DELETE
  const handleDelete = async () => {
    try {
      await axiosClient.delete(`${endpoint}/${selectedRow.id}`);
      toast({ title: "Deleted", status: "success" });
      onClose();
      await loadData();
    } catch {
      toast({ title: "Failed to delete", status: "error" });
    }
  };

  return (
    <Box w="100%">

      {/* Tabel */}
      <Table variant="simple">
        <Thead>
          <Tr>
            {columnsData.map((col, i) => (
              <Th key={i}>{col.Header}</Th>
            ))}
            <Th>Actions</Th>
          </Tr>
        </Thead>

        <Tbody>
          {data.map((row, i) => (
            <Tr key={i}>
              {columnsData.map((col, j) => (
                  <Td key={j}>
                    {col.accessor === "__index"
                        ? (page - 1) * (meta?.per_page ?? data.length) + i + 1
                        : col.Cell
                            ? col.Cell(row[col.accessor], row)
                            : row[col.accessor]}

                  </Td>
              ))}

              {/* ACTION BUTTONS */}
                <Td>
                  <Flex gap="10px">
                    <Tooltip label="Detail" hasArrow>
                      <IconButton
                        icon={<ViewIcon />}
                        size="sm"
                        colorScheme="blue"
                        style={{justifyContent:"center"}}
                        aria-label="Detail"
                        onClick={() => {
                          setSelectedRow(row);
                          onOpen();
                        }}
                      />
                    </Tooltip>
                  </Flex>
                </Td>

            </Tr>
          ))}
        </Tbody>
      </Table>

      {/* PAGINATION */}
      <Flex mt="20px" justifyContent="center" alignItems="center" gap="10px">
        <Button onClick={() => setPage((p) => Math.max(1, p - 1))} disabled={page === 1}>
          Prev
        </Button>

        <Box mt="8px">Page {page} / {meta?.total_pages ?? 1}</Box>

        <Button
          onClick={() => setPage((p) => p + 1)}
          disabled={meta?.total_pages === page}
        >
          Next
        </Button>
      </Flex>

      <CategoryDetailDialog
        isOpen={isOpen}
        onClose={onClose}
        data={selectedRow}
      />

    
    </Box>
  );
}
